<template>
  <div id="Dash">
    <!-- <h2>DASH PAGES</h2> -->

    <!-- <div class="header-container">
      <div class="header">John Heart</div>
      <DxButton     :on-click="showLoadPanel"    text="Load Data"    />
      <DxButton   :on-click="showLoadPanelFromStore"    text="TOGGLE @ store "    />
    </div>

		loadingVisible {{ loadingVisible }} <br>
		workListStore.loadingPanelVisible {{workListStore.loadingPanelVisible}} <br>
		:on-shown="onShown"
      :on-hidden="onHidden" -->

    <DxLoadPanel
      :position="position"
      v-model:visible="workListStore.loadingPanelVisible"
      :show-indicator="showIndicator"
      :show-pane="showPane"
      :shading="shading"
      :hide-on-outside-click="hideOnOutsideClick"
      shading-color="rgba(0,40,40,0.4)"
    />

    <!-- <h2 style="color:red;">
			onMount 	let sumList =  workListStore.getWidgetSummaryListFromAPI()
		</h2>
		test forceReRender
		-->
    <!-- <b-button @click="forceRerender()" variant="danger">forceRerender componentKey {{ componentKey }} </b-button> -->

    <!-- masterWidgetSummaryGridArray {{ masterWidgetSummaryGridArray }} -->
    <!-- <DashboardsContainer hidden v-show="isDASHRoute" :key="reloadDashboard" /> -->
    <!-- & WORKING CONDITION FOR rErENDER -->
    <!-- <b-button @click="forceRerender()" variant="danger">forceRerender </b-button>

		isDASHRoute {{ isDASHRoute }} <br>
		componentKey {{ componentKey }}
		reloadDashboard {{ userStore.reloadDashboard }} -->

    <!-- <h3>Dash Container</h3> -->

    <DashboardsContainerNEW v-show="isDASHRoute" :key="userStore.reloadDashboard" />

    <!-- <h3>RouterView</h3> -->
    <!-- router-view -->
    <router-view :key="userStore.reloadDashboard" />
  </div>
</template>

<script setup>
// console.clear();

import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import DashboardsContainerNEW from "@/views/Dashboard/DashboardsContainerNEW.vue";

import { DxButton } from "devextreme-vue/button";
import { DxCheckBox } from "devextreme-vue/check-box";
import { DxLoadPanel } from "devextreme-vue/load-panel";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
import { useStoreWorkList } from "@/stores/workListsStore";

const userStore = useStoreUser();
const workListStore = useStoreWorkList();

const componentKey = ref(0);

// & ROUTER
const route = useRoute();

// * a computed ref
const isDASHRoute = computed(() => {
  // console.log("isDASHRoute out: ");
  // // console.log(' this.$route.path.includes(/Summary) ')

  // console.log(" route");
  // console.log(route.path);
  const rCHK = !route.path.includes("/one");
  // console.log(" THIS ROUTE  does not  INCLUDE    /one     <<<<<<<<<<<<     ");
  // console.log("rCHK : ", rCHK);

  return !route.path.includes("/one");
});

function forceRerender() {
  showLoadPanel();
  // // console.clear()
  // console.log("				DASH PAGES :                            forceReRender KEY");
  this.componentKey += 1;
  userStore.reloadDashboard += 1;
}

const employeeInfo = ref < typeof employee > {};
const loadingVisible = ref(false);
const position = { of: "#employee" };

const showIndicator = ref(true);
const shading = ref(true);
const showPane = ref(true);
const hideOnOutsideClick = ref(false);

function showLoadPanelFromStore() {
  workListStore.toggleLoadPanel();
}

function showLoadPanel() {
  loadingVisible.value = true;
}
function onShown() {
  setTimeout(() => {
    loadingVisible.value = false;
    workListStore.loadingPanelVisible = false;
  }, 300);
}
function onHidden() {
  // employeeInfo.value = employee;
}

onMounted(() => {
  // console.clear()
  // console.log("************************************************************************************************************************");
  // console.log("onMounted() :       DASH PAGES   >>>>");
  // console.log(" isDASHRoute : ", isDASHRoute.value);

  // console.log("DASH PAGES CREated");
  // console.log("			BUILD THIS  get worklist store    this.getWidgetSummaryListFromAPI()");

  if (workListStore.primaryWidgetSummaryList.length < 1 || workListStore.workWidgetSummaryList.length < 1) {
    // console.log("  		2 STORE		workListStore.toggleLoadPanel()      >>>>>>>>>>");
    workListStore.toggleLoadPanel();

    // console.log("sumList");
    // // console.log(sumList.widgetGroups);
    // console.log("***************              getWidgetSummaryListFromAPI();      ************************************************************");
    let sumList = workListStore.getWidgetSummaryListFromAPI();
    // console.log("*************************************************************************************************************");
  }

  // console.log("                               WIDGET SUMMARIES  already    FILLED >>>>>>>>  GOOD ");

  // console.log(" TODO >>>>>>>>>>>>>>> NEW  STORE SET      currentSelectedSummaryWidget widgetGridDataArray   	setWidgetArray  ");
  // console.log(" 				TEST BIND from COMPONENT   ");
  // this.$store.commit('setWidgetArray', this.currentSelectedSummaryWidget.widgetGridDataArray)
  // this.$store.commit('setWidgetArray', this.currentSelectedSummaryWidget.widgetGridDataArray)
  // workListStore.setWidgetArray(workListStore.currentSelectedSummaryWidget.widgetGridDataArray)

  // console.log("		CHECK		PRIMARY:           workListStore.currentSelectedSummaryWidget");
  // console.log({ ...workListStore.currentSelectedSummaryWidget });

  // console.clear()
  // console.dir(workListStore.workWidgetSummaryList)

  // if (workListStore.loadingPanelVisible){
  // 	workListStore.toggleLoadPanel()
  // }

  // // console.log('TODO >>>>>>>>>>>         >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>         SET   current Selected WORK Widget ')

  // // console.log(' sETTING currentSelectedWorkSummaryWidget  = this.workWidgetSummaryList[0] ')
  // this.$store.state['workLists'].currentSelectedWorkSummaryWidget = this.workWidgetSummaryList[0]

  // // console.log(' NEW  STORE SET setWorkWidgetArray						this.currentSelectedWorkSummaryWidget.widgetGridDataArray  ')
  // this.$store.commit('setWorkWidgetArray', this.currentSelectedWorkSummaryWidget.widgetGridDataArray)
  // // console.log('   CHECk SHOULD BE this.currentSelectedWorkSummaryWidget')
  // // console.log(this.currentSelectedWorkSummaryWidget)
  // // console.log('*************************************************************************************************************')
  // // console.log('   CHECk SHOULD BE this.currentSelectedWorkSummaryWidget')
  // // console.log(this.currentSelectedWorkSummaryWidget)
  // // console.log('<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<')
});
</script>

<style scoped>
#Dash {
  /* background-color: bisque; */
  /* padding-left: 15px;

	padding-right: 15px; */
  background: transparent;
  padding: 0px;
  height: 100%;
}

div {
  text-align: center;
}

#nested {
  display: grid;
  grid-template-rows: 20% 40% 40%;
}

.flex-container {
  display: flex;
  justify-content: space-around;
}
</style>
